import React, {ReactNode, useState} from 'react'

export type TooltipPosition = 'top' | 'right' | 'left' | 'bottom';

interface TooltipWrapperProps {
  baseClasses: string;
  hoverable: ReactNode;
  children: ReactNode;
}

export const TooltipWrapper = ({baseClasses, hoverable, children}: TooltipWrapperProps) => {
  const [hidden, setHidden] = useState(true)

  return (
    <div className="relative flex">
      <div
        onMouseEnter={() => setHidden(false)}
        onMouseLeave={() => setHidden(true)}
      >
        {hoverable}
      </div>
      <div className={`${hidden ? 'hidden' : 'block'} ${baseClasses} absolute z-20`}>
        {children}
      </div>
    </div>
  )
}
